import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M12 4L4 12", stroke: "#F31260", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e.createElement("path", { d: "M4 4L12 12", stroke: "#F31260", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }));
export {
  o as default
};
